/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Form_Sklik_LabelInputs */

const cs_form_sklik_label = /** @type {(inputs: Form_Sklik_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sklik štítek ${i?.n}`)
};

const en_form_sklik_label = /** @type {(inputs: Form_Sklik_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sklik label ${i?.n}`)
};

/**
* | output |
* | --- |
* | "Sklik label {n}" |
*
* @param {Form_Sklik_LabelInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_sklik_label = /** @type {((inputs: Form_Sklik_LabelInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Sklik_LabelInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_sklik_label(inputs)
	return cs_form_sklik_label(inputs)
});